import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Auth from '../components/Auth';

const AuthScreen = (props) => {
  const mooringTransferToken =
    props?.match?.params?.mooring_transfer_token || null;
  const prefillEmail = props?.match?.params?.email || null;

  return (
    <div className='auth-screen'>
      <Container className='bg-transparent'>
        <Row className='justify-content-center'>
          <Col xs={12} lg={10} xl={8} className='px-0 px-lg-3'>
            <Auth
              mooringTransferToken={mooringTransferToken}
              prefillEmail={prefillEmail}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuthScreen;
